import { Directive } from "@angular/core";
import { BaseComponent, StorageService, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class FirmwareInstructionsBaseComponent extends BaseComponent {
  constructor(userService: UserService) {
    super(userService);
  }
}
